import { css } from 'styled-components';

const getBackGroundColor = (props) => {
  if (props.isSiteWidePromoBannerAbTestEnabled && !props.isDefaultSocialProofBanner) {
    return 'linear-gradient(118deg, #fbe64d 70%, #FCEB71 60%)';
  }
  if (props.isHolidayGetItByMessageBannerAbTestEnabled && !props.isDefaultSocialProofBanner) {
    return 'linear-gradient(118deg, #C8102E 70%, #D0344D 60%)';
  }
  return props.theme.colorPalette.white;
};

const getBackGroundColorMobile = (props) => {
  if (props.isSiteWidePromoBannerAbTestEnabled && !props.isDefaultSocialProofBanner) {
    return 'linear-gradient(118deg, #fbe64d 65%, #FCEB71 50%)';
  }
  if (props.isHolidayGetItByMessageBannerAbTestEnabled && !props.isDefaultSocialProofBanner) {
    return 'linear-gradient(118deg, #C8102E 65%, #D0344D 50%)';
  }
  return props.theme.colorPalette.white;
};

const getTextColor = (props) => {
  if (props.isSiteWidePromoBannerAbTestEnabled && !props.isDefaultSocialProofBanner) {
    return props.theme.colorPalette.black;
  }
  if (props.isHolidayGetItByMessageBannerAbTestEnabled && !props.isDefaultSocialProofBanner) {
    return props.theme.colorPalette.white;
  }
  return props.theme.colorPalette.blue[1300];
};

const getBorderColor = (props) => {
  if (props.isSiteWidePromoBannerAbTestEnabled && !props.isDefaultSocialProofBanner) {
    return 'none';
  }
  if (props.isHolidayGetItByMessageBannerAbTestEnabled && !props.isDefaultSocialProofBanner) {
    return '#C8102E';
  }
  return props.theme.colorPalette.blue[1300];
};

const styles = css`
  .social-proofing-msg-wrapper-desktop {
    display: flex;
    padding: 7px 0px 7px 42px;
    border-radius: ${(props) => props.theme.spacing.ELEM_SPACING.XS_1};
    margin: ${(props) => props.theme.spacing.ELEM_SPACING.MED} 0;
    box-shadow: 0px 8px 12px 0px rgba(0, 0, 0, 0.08);
    background: ${(props) => getBackGroundColor(props)};
    align-items: center;
  }

  .social-proofing-msg-desktop {
    padding-left: 16px;
    font-family: ${(props) => props.theme.fonts.secondaryFontFamily};
    font-size: ${(props) => props.theme.typography.fontSizes.fs16};
    font-weight: ${(props) => props.theme.fonts.fontWeight.medium};
    color: ${(props) => getTextColor(props)};
    width: ${(props) =>
      props.isDefaultSocialProofBanner ||
      props.isExtendedHolidayReturnsBannerAbTestEnabled ||
      (!props.isExtendedHolidayReturnsBannerAbTestEnabled &&
        !props.isSiteWidePromoBannerAbTestEnabled &&
        !props.isHolidayGetItByMessageBannerAbTestEnabled)
        ? '100%'
        : '65%'};

    .social-proof-checkout-msg {
      font-weight: ${(props) => props.theme.fonts.fontWeight.bold};
      @media ${(props) => props.theme.mediaQuery.smallOnly} {
        font-size: ${(props) => props.theme.typography.fontSizes.fs12};
      }
    }
  }

  .social-proofing-timer {
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      padding: 0px;
    }
    .timer-wrapper-mobile {
      display: flex;
      flex-direction: row;
    }
    .timer-wrapper {
      display: flex;
      flex-direction: column;
      padding-left: 3px;
      padding-right: 3px;
      align-items: center;
    }
    .timer-text {
      color: ${(props) => getTextColor(props)};
    }
  }
  .social-proofing-text-wrapper {
    justify-content: space-between;
    display: flex;
    width: 90%;
    align-items: center;
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      width: 88%;
    }
  }

  .social-proof-icon {
    width: ${(props) => props.theme.spacing.ELEM_SPACING.XL_1};
    height: ${(props) => props.theme.spacing.ELEM_SPACING.XL_1};
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      width: ${(props) => props.theme.spacing.ELEM_SPACING.LRG_1};
      height: ${(props) => props.theme.spacing.ELEM_SPACING.LRG_1};
    }
  }

  .social-proofing-msg-wrapper-mobile {
    display: flex;
    padding: 12px 0px 12px 12px;
    margin-bottom: ${(props) => (props.isMobileWebTileEnhancementEnabled ? '0px' : '16px')};
    align-items: center;
    margin-top: 16px;
    background: ${(props) => getBackGroundColorMobile(props)};
    border-radius: 10px;
    border: 1px solid ${(props) => getBorderColor(props)};
  }
  .social-proofing-msg-mobile {
    font-family: ${(props) => props.theme.fonts.secondaryFontFamily};
    font-weight: ${(props) => props.theme.fonts.fontWeight.semiBold};
    font-size: ${(props) => props.theme.typography.fontSizes.fs12};
    padding-left: 10px;
    color: ${(props) => getTextColor(props)};
    width: ${(props) =>
      props.isDefaultSocialProofBanner ||
      props.isExtendedHolidayReturnsBannerAbTestEnabled ||
      (!props.isExtendedHolidayReturnsBannerAbTestEnabled &&
        !props.isSiteWidePromoBannerAbTestEnabled &&
        !props.isHolidayGetItByMessageBannerAbTestEnabled)
        ? '100%'
        : '60%'};
  }
`;

export default styles;
